/* ─── Overlay ─────────────────────────────────────────────────────────────── */
.modal-overlay {
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

/* ─── Centering container ─────────────────────────────────────────────────── */
.modal-centering {
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 50%;
  margin-left: auto;
  margin-right: auto;
  pointer-events: none;
  position: fixed;
  right: auto;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
}

/* ─── Modal dialog ────────────────────────────────────────────────────────── */
.modal-dialog {
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  position: relative;
  transition:
    opacity 300ms ease,
    transform 300ms ease;
  width: 100%;
}

.modal-static-content {
  flex: 1;
  min-height: 0;
  overflow-y: hidden;
}

/* ─── Inner clip wrapper ──────────────────────────────────────────────────── */
.modal-inner {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* ─── Header ──────────────────────────────────────────────────────────────── */
.modal-header {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
}

/* ─── Scroll content ──────────────────────────────────────────────────────── */
.modal-scroll-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  /* mirrors native showsVerticalScrollIndicator={false} */
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.modal-scroll-content::-webkit-scrollbar {
  display: none;
}

/* ─── Footer ──────────────────────────────────────────────────────────────── */
.modal-footer {
  box-sizing: border-box;
  box-shadow: 0 -4px 12px rgba(12, 10, 10, 0.16);
  flex-shrink: 0;
  width: 100%;
}
